import { type ProcessedOption } from "@/components/site-builder/modules/CustomFormModule/types";
import { type FormBuilderFieldOption } from "@/types/form-builder";

export interface ProcessTreeOptionsProps {
  options: FormBuilderFieldOption[];
  hideParentCheckBoxes: boolean;
  alwaysShowHeading: boolean;
  level?: number;
}

export function processTreeOptions(
  props: ProcessTreeOptionsProps,
): ProcessedOption[] {
  const {
    options = [],
    level = 0,
    hideParentCheckBoxes,
    alwaysShowHeading,
  } = props;

  return options.map((option) => {
    const hasChildren = option.options && option.options.length > 0;

    // A parent item is a heading if:
    // 1. hideParentCheckBoxes is true, and it has children, OR
    // 2. It explicitly has selectable=false
    const isHeading =
      (hasChildren && hideParentCheckBoxes) || !option.selectable;

    // An option is selectable if:
    // 1. It's not explicitly marked as non-selectable, AND
    // 2. If it's a parent, hideParentCheckBoxes is not true
    const isSelectable =
      option.selectable !== false && !(hasChildren && hideParentCheckBoxes);

    // Determine if the option should be shown:
    // 1. If it's not selectable and has children and alwaysShowHeading is false, don't show
    // 2. Otherwise, show it
    const isShown = !(
      option.selectable === false &&
      hasChildren &&
      !alwaysShowHeading
    );

    const childOptions =
      option.options && option.options.length > 0
        ? processTreeOptions({
            options: option.options,
            hideParentCheckBoxes,
            alwaysShowHeading,
            level: level + 1,
          })
        : undefined;

    return {
      ...option,
      isSelectable,
      isHeading,
      isShown,
      level,
      childOptions,
    };
  });
}
